import { render, staticRenderFns } from "./SalaCard.vue?vue&type=template&id=19ac752d&"
import script from "./SalaCard.vue?vue&type=script&lang=js&"
export * from "./SalaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports